import { useContext } from 'react';
import { PersonContextType } from '../types';
import { PersonContext } from '../helpers/personContext';

export const usePerson = (): PersonContextType => {
	const context = useContext(PersonContext);
	if (context === undefined) {
		throw new Error('usePerson must be used within a PersonBookProvider');
	}
	return context;
};
